import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RoutingService } from '@app/core/services/routing.service';

import { UserService } from '@app/core/user';
import { SessionCookieService } from '@app/core/cookies';

@Injectable({
  providedIn: 'root'
})
export class KycEligibilityGuard implements CanActivate {
  constructor(
    private routingService: RoutingService,
    private userService: UserService,
    private sessionCookieService: SessionCookieService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const userId = this.sessionCookieService.getUserId();

    return this.userService.findUser(userId).pipe(
      map(user => user.hyperwalletActive),
      map(hyperwalletActive => {
        if (!hyperwalletActive) {
          this.routingService.redirectError('404', state.url);
        }

        return hyperwalletActive;
      })
    );
  }
}
